export default function formatTrendPercentage(str) {
    const formatted = !isNaN(parseFloat(str))
        ? String(parseFloat(str)
            .toFixed(1))
            .replace(/\.0+$/, '') + '%'
        : null;
    return (formatted === '-0%') ? '0%' : formatted;
};
